import { get } from 'svelte/store';
import { branches, categories, isShowLoader, selectedBranch } from '../store';
import { changeToken } from '../../../../Api';
import { api } from '../../../../helpers';
import { push } from 'svelte-spa-router';
const CURRENT_WIKI_BRANCH_KEY = 'currentWikiBranch';
// Защита от гонки: при быстром переключении веток применяем только ответ последнего запроса
let categoriesRequestId = 0;
const getSavedBranchPk = () => {
    try {
        const saved = JSON.parse(localStorage.getItem(CURRENT_WIKI_BRANCH_KEY));
        return saved && typeof saved.pk === 'number' ? saved.pk : null;
    }
    catch (_a) {
        return null;
    }
};
const saveBranch = (branch) => {
    localStorage.setItem(CURRENT_WIKI_BRANCH_KEY, JSON.stringify(branch));
};
const getBranches = async () => {
    const response = await api('/api/v1/wiki/branch/list/');
    if (!response.ok) {
        changeToken(response.status);
        return null;
    }
    const data = await response.json();
    const savedPk = getSavedBranchPk();
    const current = data.find((branch) => branch.pk === savedPk) || data[0] || null;
    selectedBranch.set(current);
    branches.set(data);
    return data;
};
const getCategories = async (branch) => {
    const requestId = ++categoriesRequestId;
    const response = await api(`/api/v1/wiki/page/list/?branch=${branch.pk}`);
    if (requestId !== categoriesRequestId) {
        return;
    }
    if (!response.ok) {
        changeToken(response.status);
        return;
    }
    const data = await response.json();
    if (requestId !== categoriesRequestId) {
        return;
    }
    categories.set(data);
    isShowLoader.set(false);
};
export const changeWikiBranch = async (branch) => {
    var _a;
    if (((_a = get(selectedBranch)) === null || _a === void 0 ? void 0 : _a.pk) === branch.pk) {
        return;
    }
    saveBranch(branch);
    selectedBranch.set(branch);
    categories.set([]);
    isShowLoader.set(true);
    await getCategories(branch);
};
const createLog = async (wikiCategoryId) => {
    const path = '/api/v1/logging/wiki/create/go-to-tab/';
    const method = 'POST';
    const body = JSON.stringify({ wiki_page_id: wikiCategoryId });
    const isJSON = true;
    await api(path, method, body, isJSON);
};
export const goToWikiCategoryList = async (logJump, wikiCategoryId) => {
    if (logJump) {
        await createLog(wikiCategoryId);
    }
    push(`/listwiki/wiki_pages${wikiCategoryId}`);
};
export const initWikiCategories = async () => {
    const data = await getBranches();
    if (!data) {
        return;
    }
    if (!data.length) {
        categories.set([]);
        isShowLoader.set(false);
        return;
    }
    await getCategories(get(selectedBranch));
};
